import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { AuthService } from '../shared/auth.service';
import { OrderByService } from '../shared/orderby.service';
import { BackendService } from '../shared/backend.service';
import CONFIG from 'src/config';
import { Subscription } from 'rxjs';
import { PaginationService } from '../shared/pagination.service';
import { SearchService } from '../shared/search.service';
import { MatPaginator } from '@angular/material/paginator';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  providers: [PaginationService, OrderByService,SearchService],
})
export class ViewComponent implements OnInit {
  TextSearch:FormGroup;
  term:FormControl;
  defaultSortOrder: string = '';
  active: string = '';
  result: string = '';
  items:any;
  data:any;
  entryRangeSubscription1: Subscription;
  loadingData: boolean = false;
  entryRange: Array<number>;
  originalItems: Object[] = [];
  totalEntries: number = 0;
  pagenlenth: boolean = true;
  audit: Object[] = [];
  data1:any;
  noEntrys: boolean = false;
  searchArray: Array<string> = [];
  searchFilteredItems: Object[] = [];
  exportItems: Object[] = [];
  entryRangeSubscription: Subscription;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  constructor(
    public _formBuilder:FormBuilder,
    public _router:Router,
    public _authService:AuthService,
    public orderByService: OrderByService,
    public _backendservice:BackendService,
    public _paginationService:PaginationService,
    public searchService: SearchService,
    public datePipe: DatePipe,
    //public _notificationService:NotificationService,
    //public _resetFormService: ResetFormService
  ) { }

  ngOnInit(): void {
    this.pageLoad();
    this.searchArray = ['securityID', 'applicationDate', 'applicationAmount','applicationStatus'];
    this.TextSearch=this._formBuilder.group({
      'term': ['',],
    
    })


  }
  pageLoad() {
    this._backendservice.getData( `${CONFIG.viewApiUrlBase}/${this._authService.NIBNumber}`)
      .subscribe(
        response => {
          this.loadingData = true;
      //   this.formatDataexport(response['data']);
          this.originalItems=response['data'];
          this.audit = this.originalItems;
      //console.log(this.audit);
        this.totalEntries = this.audit.length;
        this.data1=this.originalItems;
       //// console.log(this.audit.length);
        if (this.audit.length === 0) {
          this.noEntrys = true;
        }
        this.setGrid(1, this.totalEntries, "Getdata");
        this.orderBy(this.defaultSortOrder);
       //// console.log(this.data1)
       // this.data1.paginator =this.paginator;
        this.paginationGrid();
        },)
        
      
      }

  makeActive(item) {
    this.active = this.active === item ? '' : item;
}
formatDataexport(data) {
  //console.log(data);
// console.log(data);
     data.map(d => {
      d.approvedTime = this.datePipe.transform(d.approvedTime.toString(), "MM/dd/yyyy");
     // d.amount= this.numberPipe.transform(d.amount, '1.2-2');
      //console.log(data);
    })
 
}
paginationGrid() {

    this.entryRangeSubscription = this._paginationService.entryRange.subscribe(range => {
    this.entryRange = range;
    this.audit = this.originalItems.slice(this.entryRange[0], this.entryRange[1]);
    ////console.log(this.audit);
    this.totalEntries = this.audit.length;
    ////console.log(this. totalEntries );
    ////console.log(this. audit );

  });
}

setGrid(start: number, length?: number, value?: string) {
  // console.log(length);
  const sentLen = length;
  this.pagenlenth = false;
  this._paginationService.setGrid(start, sentLen);
}
searchText() {
  this.result = this.TextSearch.controls['term'].value;
 //console.log(this.result);
 //console.log(this.originalItems);
  let itemsToSearch = this.originalItems;
  this.searchService.findItemsFromMultiple(this.result, itemsToSearch, this.searchArray)
    .then(allFiltered => {
      if (this.result.length > 0) {
   // console.log("Test");
        this.audit = allFiltered;
        this.searchFilteredItems = allFiltered;
      }
      else {
        //console.log("Test2")
        this.audit = this.originalItems;
        this.searchFilteredItems = this.originalItems;
      }

      //this.pagenlenth = false;
      this.setGrid(1, this.audit.length, "search");
      this.entryRangeSubscription = this._paginationService.entryRange
        .subscribe(range => {
          this.entryRange = range;
          this.audit = this.searchFilteredItems.slice(this.entryRange[0], this.entryRange[1]);
          this.exportItems = this.originalItems;
          this.totalEntries = this.audit.length;
        });
    });
}
clearTextSearch(){
  this.TextSearch=this._formBuilder.group({
    'term': ['',],
  });
  this.searchText();
}

orderBy(param){
  let itemsToOrder = this.originalItems;
 //// console.log(itemsToOrder);
  const altParam = param === this.defaultSortOrder ? undefined : this.defaultSortOrder;
  // if(this.filterApplied && !this.term.value) {
  //     itemsToOrder = this.prefilteredItems;
  // } else if(this.term.value) {
  //     itemsToOrder = this.searchFilteredItems;
  // }
  this.items = this.orderByService.orderByParam(param, itemsToOrder, altParam);
 //// console.log(this.items);
  this.setGrid(1, itemsToOrder.length);
}
}
